import { Breadcrumbs } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import { useEntityNameForNav } from 'utils/hooks/providers/entity-name-for-nav-context';
import { removeEverythingAfter } from 'utils/string';

import './BreadcrumbNavigation.scss';

function BreadcrumbNavigation() {
  const { pathname } = useLocation();

  const { entityNameForNav } = useEntityNameForNav();

  const items = pathname.substring(1, pathname.length).split('/');

  const formatLabel = (name: string): string => {
    if (name === 'ip-networks') return 'IP Networks';
    if (name === 'schc-templates') return 'SCHC Templates';

    let label = name;
    label = label.replace('-', ' ');
    return label;
  };

  const getURI = (uriSection: string, index: number): string => {
    let newURI = '';
    // Edge cases for Flow page
    if (items[0] === 'flows') {
      if (uriSection === 'device-profiles' || uriSection === 'devices') {
        newURI = removeEverythingAfter(pathname, '/device-profiles', 'start');
        newURI += `#${uriSection}`;
      } else if (index === 1) {
        newURI = removeEverythingAfter(pathname, `/${uriSection}`, 'end');
        newURI += '#details';
      } else if (index === 0) {
        newURI = removeEverythingAfter(pathname, uriSection, 'end');
      } else {
        newURI = removeEverythingAfter(pathname, `${items[index - 1]}/${uriSection}`, 'end');
      }
    } else {
      newURI = removeEverythingAfter(pathname, uriSection, 'end');
    }
    return newURI;
  };

  if (items.length <= 1) return (<div />);
  return (
    <Breadcrumbs separator="&rsaquo;" aria-label="breadcrumb" className="path">
      {
          items.map((item, index) => {
            const label = formatLabel(item);
            if (index === items.length - 1) { // DON'T have link on the last item
              return (
                <p className="path__item" key={+index}>
                  {
                    Number.isInteger(+label)
                      ? entityNameForNav || label
                      : label
                  }
                </p>
              );
            }
            return (
              <Link to={getURI(item, index)} className="path__item" key={+index}>
                {label}
              </Link>
            );
          })
        }
    </Breadcrumbs>
  );
}

export default BreadcrumbNavigation;
